export const formsbasic = {
    itemreviewstate: {
        service:{
        name:'itemreviewstate',
        title:'Item Review State',
        }
    },
    requisitionitemstate: {
        service:{
        name:'requisitionitemstate',
        title:'Item Review State',
        }
    },
    requisitionitemtype: {
        service:{
        name:'requisitionitemtype',
        title:'Item Review State',
        }
    },
    uom: {
        service:{
        name:'uom',
        title:'UOM',
        }
    },
    resourcetype: {
        service:{
        name:'resourcetype',
        title:'Resource Type',
        }
    },
    priority: {
        service:{
        name:'priority',
        title:'Priority',
        }
    },
}